import React from 'react';
import { SitemapNode } from '../../../extViewmodels/sdk/models/Website';
import { BreadcrumbBar } from '../../components-v2/BreadcrumbBar';
import { WEBSITE_EDITOR_PATH, WEBSITE_PATH } from './routes';

interface Props {
	sitemap?: SitemapNode[];
	/** Root-relative path of the page in the preview, e.g. `/services/roofing`; unset outside the editor. */
	pagePath?: string;
}

/**
 * The AppBar's breadcrumb slot. NavigationBreadcrumbsBar builds its crumbs from the pathname, and the open page
 * lives in the query string, so the crumbs are assembled here instead.
 */
export function WebsiteBreadcrumbs({ sitemap, pagePath }: Props) {
	if (pagePath === undefined) {
		return <BreadcrumbBar items={[{ label: 'Website', path: WEBSITE_PATH }]} />;
	}
	const pageName = sitemap?.find(node => node.resolvedUrl === pagePath)?.pageName;
	return (
		<BreadcrumbBar
			items={[
				{ label: 'Website', path: WEBSITE_PATH },
				{ label: 'Editor', path: WEBSITE_EDITOR_PATH },
				...(pageName ? [{ label: pageName }] : []),
			]}
		/>
	);
}
